<script>
	import InfoPage from './InfoPage.svelte';
	import InfoSection from './InfoSection.svelte';
	import { Icon } from '../feathericons.js';

</script>

<InfoPage Title="Whaddon">

<svelte:fragment slot="blurb">
<InfoSection src="pics/whaddon.jpg" alt="Whaddon">
<p>A small village near Wimpole that has a nice pack next to its village hall.</p>
<p><a href="http://www.whaddon.org/village-hall" target="new">{@html Icon("external-link","small")} Whaddon website</a></p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="playgrounds">
<InfoSection id="Whaddon_Playground" Title="Whaddon Playground" src="pics/whaddon-park-1.jpg" alt="Whaddon Playground">
<p>This playground features a section for younger kids, older kids, and an obstacles course. It is right next to a cricket ground and makes a good spot for a picnic.</p>
</InfoSection>

</svelte:fragment>
</InfoPage>
